export default {"src":"/_next/static/media/logo-white.ef2cc829.svg","height":82,"width":200,"blurWidth":0,"blurHeight":0};